(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9419],{

/***/ 44174:
/***/ (function(module) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),

/***/ 81119:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),

/***/ 14259:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 57406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    last = __webpack_require__(10928),
    parent = __webpack_require__(40292),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ 55189:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(44174),
    baseAggregator = __webpack_require__(81119),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),

/***/ 82710:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPlainObject = __webpack_require__(68630);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ 99021:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var flatten = __webpack_require__(85564),
    overRest = __webpack_require__(45357),
    setToString = __webpack_require__(30061);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ 40292:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786),
    baseSlice = __webpack_require__(14259);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ 85564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 68630:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    getPrototype = __webpack_require__(85924),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 24350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    createAggregator = __webpack_require__(55189);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),

/***/ 10928:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 66604:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    baseForOwn = __webpack_require__(47816),
    baseIteratee = __webpack_require__(67206);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ 57557:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseClone = __webpack_require__(85990),
    baseUnset = __webpack_require__(57406),
    castPath = __webpack_require__(71811),
    copyObject = __webpack_require__(98363),
    customOmitClone = __webpack_require__(82710),
    flatRest = __webpack_require__(99021),
    getAllKeysIn = __webpack_require__(46904);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ 19419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ contact_sales_hubspot_form_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hubspot-form/dist/index.js
var dist = __webpack_require__(67967);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
;// CONCATENATED MODULE: ./components/core/loader/monday-loader-component.js







var MONDAY_LOADER_IMAGE = {
    src: "/static/img/loader/monday_loader.gif"
};
var MondayLoaderComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MondayLoaderComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MondayLoaderComponent);
    function MondayLoaderComponent(props) {
        (0,_class_call_check/* default */.Z)(this, MondayLoaderComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(MondayLoaderComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "loader-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                        image: MONDAY_LOADER_IMAGE
                    })
                });
            }
        }
    ]);
    return MondayLoaderComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./client/services/hubspot-service/contact-form-config.js + 1 modules
var contact_form_config = __webpack_require__(49228);
// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-service.js + 1 modules
var hubspot_service = __webpack_require__(24660);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(19755);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);
// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-constants.js
var hubspot_constants = __webpack_require__(22638);
// EXTERNAL MODULE: ./node_modules/lodash/mapValues.js
var mapValues = __webpack_require__(66604);
var mapValues_default = /*#__PURE__*/__webpack_require__.n(mapValues);
// EXTERNAL MODULE: ./node_modules/lodash/keyBy.js
var keyBy = __webpack_require__(24350);
var keyBy_default = /*#__PURE__*/__webpack_require__.n(keyBy);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__(57557);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/side-by-side-hubspot-form/components/contact-sales-hubspot-form-component.scss.js




var StyledContactSalesHubspotFormComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1sejyam0"
})(".monday-loader-wrapper{width:100%;display:flex;justify-content:center;align-items:center;}> div{width:100%;}background:", colors/* default.white */.Z.white, ';padding:48px;box-shadow:0px 8px 24px rgba(0,0,0,0.100091);border-radius:12px;margin:24px 12px;display:flex;justify-content:center;align-items:center;#reactHubspotForm2{display:flex;justify-content:center;}.hbspt-form{fieldset{max-width:100%;text-align:left;&.form-columns-1,&.form-columns-2{.hs-form-field{text-align:left;margin-bottom:30px;font-size:0.731rem;position:relative;}.hs-input{width:100%;}.legal-consent-container{.hs-richtext{font-size:0.75rem;text-align:center;}}.hs-fieldtype-booleancheckbox{margin-bottom:8px;.inputs-list{padding-inline-start:8px;.hs-form-booleancheckbox{.hs-form-booleancheckbox-display{display:flex;align-items:center;.hs-input[type="checkbox"]{width:unset;height:unset;margin-right:8px;}}::marker{color:transparent;}}}}}&.form-columns-1{.hs-form-field{width:100%;}}&.form-columns-2{.hs-form-field{width:50%;}}.input{input,select,textarea{height:40px;border-radius:4px;border:#d3d2d2 1px solid;text-indent:10px;color:#333;width:100%;outline:none;}select{text-indent:10px;}textarea{height:80px;width:100% !important;resize:none;}ul[role="checkbox"]{padding-inline-start:8px;.hs-form-checkbox{.hs-form-checkbox-display{display:flex;align-items:center;.hs-input[type="checkbox"]{width:unset;height:unset;margin-right:8px;}}::marker{color:transparent;}}}}.hs-form-field{label{margin-bottom:5px;display:inline-block;text-indent:5px;font-size:0.875rem;color:', colors/* default.black */.Z.black, ";}}.invalid.error{border-color:", colors/* default.brand-red */.Z["brand-red"], ";}}.hs-form-required{margin-left:8px;color:", colors/* default.brand-red */.Z["brand-red"], ";}.no-list{&.hs-error-msgs{padding-left:0;margin-top:2px;&.inputs-list{list-style-type:none !important;position:absolute;margin-left:5px;width:100%;&:not(:first-of-type){display:none;}li > label > a{display:none;}label{font-size:0.6875rem;text-indent:0px;}}}}.hs_submit{display:flex;justify-content:center;input{user-select:none;line-height:17px;outline:none;text-align:center;cursor:pointer;border-radius:40px;border:none;font-size:0.875rem;transition:0.1s ease background-color;padding:14px 32px;font-weight:300;background:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";color:", colors/* default.white */.Z.white, ";}}.hs_how_can_our_consulting_team_help_you{margin-bottom:5px;display:inline-block;font-size:0.731rem;width:100%;}.hs_error_rollup{display:none;}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){padding:24px 12px 80px 12px;margin:24px 0;}");

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/side-by-side-hubspot-form/components/contact-sales-hubspot-form-component.js

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



















var LOCALE_QUERY_PARAM = "locale";
var getLocaleFormQueryParam = function() {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams === null || urlParams === void 0 ? void 0 : urlParams.get(LOCALE_QUERY_PARAM);
};
var ContactSalesHubspotFormComponent = function(props) {
    var formId = props.formId, urlToRedirectAfterSubmission = props.urlToRedirectAfterSubmission, formMinHeight = props.formMinHeight, withPrivacyNotice = props.withPrivacyNotice, source = props.source, abTests = props.abTests, cookies = props.cookies, cloudfrontViewerCountry = props.cloudfrontViewerCountry, translate = props.translate, localeId = props.localeId, webflowPageLocaleQueryParam = props.webflowPageLocaleQueryParam;
    var labelIdToText = {
        "label-firstname": translate("forms.fieldTitle.requiredFirstName"),
        "label-lastname": translate("forms.fieldTitle.requiredLastName"),
        "label-email": translate("forms.fieldTitle.requiredWorkEmail"),
        "label-jobtitle": translate("contactSales.hubspotForm.form.fieldTitle.jobTitle"),
        "label-event___job_title": translate("contactSales.hubspotForm.form.fieldTitle.jobTitle"),
        "label-phone": translate("forms.fieldTitle.requiredPhoneNumber"),
        "label-company": translate("contactSales.hubspotForm.form.fieldTitle.requiredCompanyName"),
        "label-company_size__c": translate("forms.fieldTitle.RequiredCompanySize"),
        "label-product_question_hs_forms": translate("contactSales.hubspotForm.form.fieldTitle.productQuestion"),
        "label-how_can_our_consulting_team_help_you": translate("contactSales.hubspotForm.form.fieldTitle.howCanHelp"),
        "label-country_picklist": translate("contactSales.hubspotForm.form.productQuestion.country")
    };
    var renderLoadingState = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "monday-loader-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MondayLoaderComponent, {})
        });
    };
    (0,react.useEffect)(function() {
        // needed for Hubspot form to send submit callback
        window.jQuery = window.jQuery || (jquery_default());
    }, []);
    var onReady = function() {
        // We attach visitor_id as hidden field so we can track from
        // which LPs users make the Hubspot form submissions
        var hiddenData = (0,hubspot_service/* generateHiddenData */.OB)({
            withPrivacyNotice: withPrivacyNotice,
            source: source,
            abTests: abTests,
            cookies: cookies,
            cloudfrontViewerCountry: cloudfrontViewerCountry
        });
        hiddenData.forEach(function(data) {
            var hiddenField = document.querySelector('input[name="'.concat(data.name, '"]'));
            if (hiddenField) {
                hiddenField.value = data.value;
            }
        });
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HUBSPOT_FORM_READY, {
            kind: formId
        });
    };
    var onSubmit = function(formData) {
        var _formData_find;
        var companySize = formData === null || formData === void 0 ? void 0 : (_formData_find = formData.find(function(field) {
            return field.name === hubspot_constants/* HUBSPOT_API_COMPANY_SIZE */.h4;
        })) === null || _formData_find === void 0 ? void 0 : _formData_find.value;
        (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).HUBSPOT_FORM_SUBMITTED, {
            formId: formId
        });
        var data;
        try {
            data = omit_default()(_object_spread_props(_object_spread({}, mapValues_default()(keyBy_default()(formData, "name"), "value")), {
                leadsource: source
            }), (0,_to_consumable_array/* default */.Z)(hubspot_constants/* PII_PARAMS */.TO).concat([
                "hs_context"
            ]));
        } catch (e) {
            esm_exports/* captureException */.Tb(e);
        }
        data = _object_spread_props(_object_spread({}, data || {}), {
            country: cloudfrontViewerCountry,
            language: localeId
        });
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HUBSPOT_FORM_SUBMIT_CLICKED, {
            kind: formId,
            info1: companySize,
            data: data
        });
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.HUBSPOT_FORM_SUBMIT_SUCCESS, {
            kind: formId,
            info1: companySize,
            data: data
        });
        if (urlToRedirectAfterSubmission) {
            window.parent.postMessage({
                type: "formSubmit",
                redirectUrl: urlToRedirectAfterSubmission
            }, "*");
        }
    };
    var translateLabels = function(mutationsList, observer) {
        try {
            if (observer) observer.disconnect();
            var labels = document.querySelectorAll(".hs-form label");
            var legalConsent = document.querySelector(".legal-consent-container p");
            var legalConsentLink = legalConsent === null || legalConsent === void 0 ? void 0 : legalConsent.querySelector("a");
            var contactUsButton = document.querySelector(".hs-button.primary.large");
            mutationsList === null || mutationsList === void 0 ? void 0 : mutationsList.forEach(function(mutation) {
                if (mutation.type === "childList") {
                    labels === null || labels === void 0 ? void 0 : labels.forEach(function(label) {
                        var id = label.id.replace("-".concat(formId), "");
                        label.textContent = labelIdToText[id];
                    });
                    if (legalConsent) {
                        var _legalConsent_childNodes;
                        legalConsent === null || legalConsent === void 0 ? void 0 : (_legalConsent_childNodes = legalConsent.childNodes) === null || _legalConsent_childNodes === void 0 ? void 0 : _legalConsent_childNodes.forEach(function(node) {
                            if (node.nodeType === Node.TEXT_NODE) {
                                node.nodeValue = translate("forms.privacyNoticeShortenWithoutParam");
                            }
                        });
                        if (legalConsentLink) {
                            legalConsentLink.textContent = translate("forms.privacyPolicy");
                        }
                    }
                    if (contactUsButton) {
                        contactUsButton.value = translate("contactSales.hubspotForm.form.contactUsButton");
                    }
                }
            });
        } catch (e) {
            esm_exports/* captureException */.Tb(e);
        } finally{
            if (observer) {
                var targetNode = document.querySelector(".contact-sales-hubspot-form-component");
                var config = {
                    childList: true,
                    subtree: true
                };
                observer.observe(targetNode, config);
            }
        }
    };
    (0,react.useEffect)(function() {
        if (localeId || webflowPageLocaleQueryParam) {
            var observer = new MutationObserver(function(mutationsList) {
                return translateLabels(mutationsList, observer);
            });
            var targetNode = document.querySelector(".contact-sales-hubspot-form-component");
            var config = {
                childList: true,
                subtree: true
            };
            observer.observe(targetNode, config);
            return function() {
                observer.disconnect();
            };
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContactSalesHubspotFormComponent, {
        className: "contact-sales-hubspot-form-component",
        style: {
            minHeight: formMinHeight
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
            portalId: contact_form_config/* PORTAL_ID */.Im,
            formId: formId,
            loading: renderLoadingState(),
            onReady: onReady,
            cssClass: "hbspt-form",
            onSubmit: onSubmit
        })
    });
};
/* harmony default export */ var contact_sales_hubspot_form_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(ContactSalesHubspotFormComponent)));


/***/ }),

/***/ 67967:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
	value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(73935);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var globalId = 0;

var HubspotForm = function (_React$Component) {
	_inherits(HubspotForm, _React$Component);

	function HubspotForm(props) {
		_classCallCheck(this, HubspotForm);

		var _this = _possibleConstructorReturn(this, (HubspotForm.__proto__ || Object.getPrototypeOf(HubspotForm)).call(this, props));

		_this.state = {
			loaded: false
		};
		_this.id = globalId++;
		_this.createForm = _this.createForm.bind(_this);
		_this.findFormElement = _this.findFormElement.bind(_this);
		return _this;
	}

	_createClass(HubspotForm, [{
		key: 'createForm',
		value: function createForm() {
			var _this2 = this;

			if (window.hbspt) {
				// protect against component unmounting before window.hbspt is available
				if (this.el === null) {
					return;
				}
				var props = _extends({}, this.props);
				delete props.loading;
				delete props.onSubmit;
				delete props.onReady;
				var options = _extends({}, props, {
					target: '#' + this.el.getAttribute('id'),
					onFormSubmit: function onFormSubmit($form) {
						// ref: https://developers.hubspot.com/docs/methods/forms/advanced_form_options
						var formData = $form.serializeArray();
						_this2.props.onSubmit(formData);
					}
				});
				window.hbspt.forms.create(options);
				return true;
			} else {
				setTimeout(this.createForm, 1);
			}
		}
	}, {
		key: 'loadScript',
		value: function loadScript() {
			var _this3 = this;

			var script = document.createElement('script');
			script.defer = true;
			script.onload = function () {
				_this3.createForm();
				_this3.findFormElement();
			};
			script.src = '//js.hsforms.net/forms/v2.js';
			document.head.appendChild(script);
		}
	}, {
		key: 'findFormElement',
		value: function findFormElement() {
			// protect against component unmounting before form is added
			if (this.el === null) {
				return;
			}
			var form = this.el.querySelector('iframe');
			if (form) {
				this.setState({ loaded: true });
				if (this.props.onReady) {
					this.props.onReady(form);
				}
			} else {
				setTimeout(this.findFormElement, 1);
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (!window.hbspt && !this.props.noScript) {
				this.loadScript();
			} else {
				this.createForm();
				this.findFormElement();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement('div', {
					ref: function ref(el) {
						return _this4.el = el;
					},
					id: 'reactHubspotForm' + this.id,
					style: { display: this.state.loaded ? 'block' : 'none' }
				}),
				!this.state.loaded && this.props.loading
			);
		}
	}]);

	return HubspotForm;
}(_react2.default.Component);

exports["default"] = HubspotForm;
module.exports = exports['default'];

//# sourceMappingURL=index.js.map

/***/ })

}]);